/* eslint-disable react/react-in-jsx-scope */
import { Route } from 'react-router-dom';
// import { PrivateRoute } from '~/main/routes/PrivateRoute';

import { MakeConfPage } from '~/main/factories/pages/conf';

const RoutesConf = [<Route exact path="/conf" component={MakeConfPage} />];

export default RoutesConf;
